import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = ({ users }) => {
    const empty = (users.length === 0);
    if (empty) {
        return (
            <div className="rounded-0 alert alert-warning m-0">
                Nenhum usuário cadastrado.
            </div>
        ); 
    }
    return (
        <div className="table-responsive">
            <table className="table align-items-center table-flush">
                <TableHead />
                <TableBody users={users} />
            </table>
        </div>
    );
};

export default Table;


// WEBPACK FOOTER //
// ./src/components/Pages/Users/Table.js